import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const HomePage = lazy(
  () => import('./HomePage.eager').then(mod => ({default: mod.HomePage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
